import { css } from '@emotion/react';

import image from 'src/assets/jpg/succes-failure-hero.jpg';
import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    }),

    imageContainer: css({
        marginBottom: '50px',
        height: '190px',
        flexShrink: '0',
        background: `url(${image}) lightgray no-repeat center/cover`,
        backgroundPosition: '45% 32%',
        backgroundSize: '150%',

        [theme.breakpoints.up('lg')]: {
            backgroundSize: '100%',
        },
    }),

    wrapper: css({
        padding: '0 20px',
        alignSelf: 'center',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '30px',
        marginBottom: '85px',
        [theme.breakpoints.up('lg')]: {
            gap: '40px',
        },
    }),

    content: css({
        textAlign: 'left',
    }),

    cta: css({
        display: 'flex',
        height: '45px',
        padding: '16px 16px 12px 16px',
        justifyContent: 'center',
        gap: '30px',
        alignItems: 'stretch',
        borderRadius: '100px',
        paddingBlock: '16px',
        width: '100%',
        alignSelf: 'stretch',
        textTransform: isHosTheme ? 'none' : 'uppercase',
        [theme.breakpoints.up('lg')]: {
            width: '186px',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    }),

    bold: css({
        fontWeight: 700,
    }),
};
